import React, { memo } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import PreviewIcon from '@mui/icons-material/Preview';
import { FieldMetadata } from '../../../../contexts/MetadataContext';

interface HelpTextFieldItemProps {
  field: FieldMetadata;
  value: string;
  onChange: (value: string) => void;
  onPreview: () => void;
}

const HelpTextFieldItem: React.FC<HelpTextFieldItemProps> = memo(
  ({ field, value, onChange, onPreview }) => {
    return (
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          alignItems: 'flex-start',
          py: 1.5,
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Box sx={{ width: 220, flexShrink: 0 }}>
          <Typography sx={{ fontWeight: 'bold' }}>{field.Key}</Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {field.LocaleKey}
          </Typography>
        </Box>
        <TextField
          fullWidth
          multiline
          minRows={2}
          placeholder="Enter help text (HTML supported)..."
          value={value}
          onChange={(e) => onChange(e.target.value)}
          size="small"
          slotProps={{
            input: {
              sx: {
                alignItems: 'flex-start',
                '& textarea': {
                  resize: 'vertical',
                },
              },
            },
          }}
        />
        <Button
          variant="outlined"
          size="small"
          startIcon={<PreviewIcon />}
          onClick={onPreview}
          sx={{ minWidth: 100, height: 40, flexShrink: 0 }}
        >
          Preview
        </Button>
      </Box>
    );
  },
);

HelpTextFieldItem.displayName = 'HelpTextFieldItem';

export default HelpTextFieldItem;
